jQuery(document).ready(function () {

	jQuery('.js-req-wiley-library-access').on('click', function (e) {
		e.preventDefault();
		const originalText = jQuery(this).text();
		const message$ = jQuery('.js-wiley-library-access-message');
		var button$ = jQuery(this);
		message$.addClass('d-none');
		button$.attr('disabled', true).text('Requesting access...');

		jQuery.ajax({
			url: wiley_ajax.ajax_url,
			method: 'post',
			data: {
				'action': wiley_ajax.action_name,
				'domain': jQuery(this).data('domain'),
				'nonce': jQuery(this).data('nonce'),
				'url_target': jQuery(this).data('url-target'),
			},
			success: function (response) {
				if (typeof response.data !== 'undefined' && typeof response.data.url_redirect !== 'undefined') {
					button$.text('Successful request, redirecting you...');
					window.location.href = response.data.url_redirect;
				}
			},
			error: function (response) {
				response = response.responseJSON;
				button$.attr('disabled', false).text(originalText);
				message$.removeClass('d-none').text(response.data.message);
			}
		});
	});
});
